<style lang="less" scoped>
    .container{
        background: white;
        position: relative;
    }
    .handlers{
        padding: 5px;
    }
    .full-screen{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
    }
    .canvas-container{
        position: relative;
        display: inline-block;
        width: 800px;
    }
    .img-container{
        position: relative;
        display: inline-block;
        width: 800px;
        img{
            width: 100%;
        }
    }
    .file-uploader{
        display: inline-block;
        vertical-align: middle;
        line-height: 1;
    }
    .file-uploader /deep/ .ivu-upload-list{
        display: none;
    }
    .canvas{
        border: 1px solid #dddee1;
        font-family: 'Gloria Hallelujah', "Hannotate SC", "HanziPen SC", "Kaiti SC", sans-serif;
    }
    .coordinate{
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        padding: 3px 6px;
        border: 1px solid #dddee1;
        background: white;
        /*transition: .1s;*/
    }
    .item-list{
        display: inline-block;
        position: absolute;
        top: 0;
        left: 805px;
        right: 0;
        bottom: 0;
        overflow: auto;
        margin-top: 27px;
        padding-bottom: 250px;
    }
    .draggable-header{
        width: 180px;
    }
    .draggable-item{
        border: 1px solid #ddd;
        padding: 5px;
        width: 180px;
        cursor: move;
        &:hover{
            box-shadow: 0 1px 3px rgba(55,55,55,.2);
        }
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
    .office-map-label{
        position: absolute;
        display: inline-block;
        padding: 2px 4px;
        border-radius: 4px;
        border: 1px solid #f5f5f5;
        color: #444;
        font-size: 16px;
        font-family: FZShuTi, STXingkai, monospace;
    }
</style>
<template>
  <div
    class="container"
    :class="{'full-screen': full_screen}"
    tabindex="1"
    @keydown.stop.prevent="pageKeyDown"
  >
    <div class="handlers">
      <Button
        size="small"
        icon="md-add"
        @click.stop="editMap(new_map)"
      >
        添加地图
      </Button>
      <Select
        v-if="!updating_map_selector"
        :value="cur_map.id"
        size="small"
        style="width: 200px"
        placeholder="选择你要编辑的地图"
        @on-change="selectMap"
      >
        <Option
          v-for="map in maps"
          :key="map.id"
          :value="map.id"
        >
          {{ map.name }}
        </Option>
      </Select>
      <span v-if="cur_map.id">
        <Button
          size="small"
          type="primary"
          @click.stop="editMap(cur_map)"
        >修改名称</Button>
        <Ajaxbtn
          :url="update_path"
          type="update"
          :params="update_params"
          :config="update_config"
          @done="handleUpdateData"
          @fail="handleUpdateFail"
        />
        <span v-if="!img_url">
          <Dropdown @on-click="addShape">
            <Button
              size="small"
              type="primary"
              icon="md-add"
            >
              添加图形
              <Icon type="ios-arrow-down" />
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem
                name="line"
                :disabled="isShapeActive('line')"
              >直线</DropdownItem>
              <DropdownItem
                name="rectangle"
                :disabled="isShapeActive('rectangle')"
              >矩形</DropdownItem>
              <DropdownItem
                name="circle"
                :disabled="isShapeActive('circle')"
              >圆</DropdownItem>
              <DropdownItem
                name="ellipse"
                :disabled="isShapeActive('ellipse')"
              >椭圆</DropdownItem>
              <DropdownItem
                name="linearPath"
                :disabled="isShapeActive('linearPath')"
              >路径</DropdownItem>
              <DropdownItem
                name="polygon"
                :disabled="isShapeActive('polygon')"
              >多边形</DropdownItem>
              <DropdownItem
                name="arc"
                :disabled="isShapeActive('arc')"
              >弧形</DropdownItem>
              <DropdownItem
                name="curve"
                :disabled="isShapeActive('curve')"
              >曲线</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <Button
            size="small"
            type="primary"
            icon="md-add"
            :disabled="isLabelActive()"
            @click.stop="addLabel"
          >标签</Button>
          <Button
            size="small"
            @click.stop="selectAllItem"
          >全选</Button>
          <Button
            size="small"
            @click.stop="clearSelectItem"
          >反选</Button>
        </span>
        <FileUploader
          class="file-uploader"
          :upload_path="$util.api.upload_to_oss_public"
          :format="['jpg', 'jpeg', 'png']"
          @done="fileUploaded"
        >
          <Button
            size="small"
            type="warning"
          >上传图片</Button>
        </FileUploader>
        <Button
          v-if="cur_map.img_addr"
          size="small"
          type="warning"
          @click.stop="cur_map.img_addr = ''"
        >清除图片</Button>
        <Button
          v-if="!full_screen"
          size="small"
          icon="md-expand"
          @click.stop="toggleFullScreen"
        />
        <Button
          v-else
          size="small"
          icon="md-contract"
          @click.stop="toggleFullScreen"
        />
      </span>
    </div>
    <div
      v-if="img_url"
      class="img-container"
    >
      <img :src="img_url">
    </div>
    <div
      v-show="!img_url"
      class="canvas-container"
    >
      <canvas
        ref="canvas"
        class="canvas"
        :style="canvas_style"
        :width="canvas_width"
        :height="canvas_height"
        @click="click"
        @mouseover="mouseOver"
        @mouseout="mouseOut"
        @mousemove="mouseMove"
        @mousedown="mouseDown"
      />
      <div
        v-show="show_coordinate"
        class="coordinate"
        :style="coordinate_style"
      >
        {{ coordinate_text }}
      </div>
    </div>
    <div class="item-list">
      <Shape
        v-for="(item, index) in select_items"
        :class="{'cur-shape': isItemSelected(item)}"
        :key="item.id"
        :item="item"
        :index="index"
        @click="selectItem"
        @change="reDraw"
        @copy="copyItem"
        @del="delItem"
      />
      <MapLabel
        v-for="(label, index) in select_labels"
        :class="{'cur-label': isLabelSelected(label)}"
        :key="label.id"
        :label="label"
        :index="index"
        @click="selectLabel"
        @change="reDraw"
        @copy="copyLabel"
        @del="delLabel"
      />

      <div
        v-if="cur_map.items.length"
        class="line"
      >
        <Draggable
          v-model="cur_map.items"
          ghost-class="ghost"
          draggable=".draggable-item"
        >
          <div
            v-for="(item,index) in cur_map.items"
            :key="item.id"
            class="draggable-item"
            @mouseenter="hlItem(item)"
            @mouseleave="reDraw"
          >
            {{ item.shape }}
          </div>
        </Draggable>
      </div>
    </div>

    <Modal
      v-model="edit_config.modal"
      :loading="edit_mode.loading"
      @on-ok="updateMap"
    >
      <Form
        :label-width="60"
        :model="edit_map"
        style="margin-top: 50px;"
      >
        <FormItem
          prop="name"
          label="名称"
          :rules="{required: true, message: '名称不能为空'}"
        >
          <i-input v-model="edit_map.name" />
        </FormItem>
        <!--<FormItem prop="office_id" label="地点">
                    <Select v-model="edit_map.office_id"></Select>
                </FormItem>-->
      </Form>
    </Modal>
  </div>
</template>
<script route="/other/office_map">
  import Rough from 'roughjs/dist/rough.es5.umd';
  import RoughUtil from '../../libs/rough_util';
  import Shape from '../components/rough_shape/shape';
  import MapLabel from '../components/rough_shape/label';
  import FileUploader from '../components/file/uploader';
  import Draggable from 'vuedraggable';
  import {mapGetters} from "vuex";
  export default {
    /* router_info_start */
    router_info: '/other/office_map',
    /* router_info_end */

    components: { Shape, MapLabel, FileUploader, Draggable },
    data() {
      return {
        update_path: Util.api.office_map_update,
        update_config: {
          size: 'small',
          type: 'primary'
        },
        full_screen: false,
        show_coordinate: false,
        coordinate: {x: 0, y: 0},
        new_map: {
          id: 0,
          office_id: 0,
          name: '',
          content: '',
          labels: '',
          img_addr: '',
        },
        edit_map: {},
        edit_config: {
          modal: false,
          loading: true
        },
        updating_map_selector: false,
        maps: [],
        map_hash: {},
        cur_map: {items: [], labels: []},
        edit_mode: 'shape',
        select_items: [],
        new_item: null,
        default_item: {
          line: {
            x1: 0,
            y1: 0,
            x2: 20,
            y2: 20
          },
          rectangle: {
            x: 0,
            y: 0,
            w: 30,
            h: 20
          },
          ellipse: {
            x: 0,
            y: 0,
            w: 30,
            h: 20
          },
          circle: {
            x: 0,
            y: 0,
            d: 20
          },
          linearPath: {
            points: [
              {x: 0, y: 0},
              {x: 20, y: 20},
              {x: 30, y: 40}
            ]
          },
          polygon: {
            points: [
              {x: 0, y: 0},
              {x: 20, y: 20},
              {x: 30, y: 40}
            ]
          },
          arc: {
            x: 0,
            y: 0,
            w: 60,
            h: 60,
            // start: Math.PI / 2,
            start: 0,
            stop: Math.PI * 3 / 4,
            closed: true
          },
          curve: {
            points: [
              {x: 10, y: 10},
              {x: 15, y: 15},
              {x: 25, y: 5},
              {x: 30, y: 15},
            ]
          },
          path: {
            val: ''
          }
        },
        default_option: {
          roughness: 1,
          bowing: 1,
          stroke: '#000000',
          strokeWidth: 1,
          fill: 'red',
          fillStyle: 'hachure', //or solid
          fillWeight: 0.5,
          hachureAngle: -41,
          hachureGap: 4,
          curveStepCount: 9,
          simplification: 0, //0-1
        },
        new_label: null,
        default_label: {
          shape: 'label',
          text: '文字标签',
          x: 0,
          y: 0,
          w: 0,
          h: 0,
          font: "'Gloria Hallelujah','Hannotate SC','HanziPen SC','Kaiti SC','sans-serif'",
          fillStyle: '#000',
          fontWeight: 'bold',
          textAlign: 'left',
          textBaseline: 'top',
          fontSize: 20
        },
        select_labels: [],
        hl_color: 'blue',
      }
    },
    computed: {
      update_params() {
        const params = Util.clone(this.cur_map);
        params.content = params.items ? JSON.stringify(params.items) : '[]';
        params.labels = params.labels ? JSON.stringify(params.labels) : '[]';
        delete params.items;
        return params;
      },
      update_edit_params() {
        const params = Util.clone(this.edit_map);
        params.content = params.items ? JSON.stringify(params.items) : '[]';
        params.labels = params.labels ? JSON.stringify(params.labels) : '[]';
        delete params.items;
        return params;
      },
      canvas_width() {
        return this.cur_map.width ? this.cur_map.width : 800;
      },
      canvas_height() {
        return this.cur_map.height ? this.cur_map.height : 600;
      },
      canvas_style() {
        return {
          cursor: this.new_item ? 'crosshair' : 'auto'
        }
      },
      coordinate_style() {
        return {
          transform: `translate3d(${this.coordinate.x + 4}px, ${this.coordinate.y - 30}px, 0)`,
        }
      },
      coordinate_text() {
        return `${this.coordinate.x},${this.coordinate.y}`;
      },
      ...mapGetters({
        offices: 'async/offices',
      }),
      img_url() {
        return this.cur_map.img_addr ? `${this.$util.publicOSSUrl(this.cur_map.img_addr)}?x-oss-process=style/map` : '';
      }
    },
    created() {
      this.init();
    },
    mounted() {
      this.initCanvas();
      window.aa = this;
    },
    methods: {
      init() {
        window.map = this;
        this.getMaps();
      },
      initCanvas() {
        this.ctx = this.$refs.canvas.getContext('2d');
        this.rc = Rough.canvas(this.$refs.canvas);
        this.generator = this.rc.generator;
      },
      getMaps() {
        Util.ajax.get(Util.api.office_map_list).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            //this.maps = [];
            data.maps.forEach((map) => {
              map.items = map.content ? JSON.parse(map.content) : [];
              map.labels = map.labels ? JSON.parse(map.labels) : [];
              delete map.content;
              //this.maps.push(map);
              this.map_hash[map.id] = map;
            });
            this.maps = data.maps;
            this.fixItemLabelId();
          } else {
            this.$Modal.error({title: '提示', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.error({title: '提示', content: e.message});
        });
      },
      fixItemLabelId() {
        this.maps.forEach((map) => {
          map.items.forEach((item) => {
            if (!item.hasOwnProperty('id')) {
              item.id = Util.guid();
            }
          });
          map.labels.forEach((label) => {
            if (!label.hasOwnProperty('id')) {
              label.id = Util.guid();
            }
            Object.keys(this.default_label).forEach((key) => {
              if (!label.hasOwnProperty(key)) {
                label[key] = this.default_label[key];
              }
            });
          });
        });
      },
      editMap(map) {
        this.edit_map = Util.clone(map);
        this.edit_config.modal = true;
      },
      updateMap() {
        Util.ajax.post(Util.api.office_map_update, this.update_edit_params).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const map = res.data.map;
            map.items = map.content ? JSON.parse(map.content) : [];
            map.labels = map.labels ? JSON.parse(map.labels) : [];
            delete map.content;
            this.$util.insertOrUpdateArrayItem(this.maps, map);
            this.map_hash[map.id] = map;
            this.edit_config.modal = false;
            this.selectMap(map.id);
          } else {
            this.$Modal.error({title: '提示', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.error({title: '提示', content: e.message});
        }).finally(() => {
          this.edit_config.loading = false;
          setTimeout(() => {
            this.edit_config.loading = true;
          }, 500);
        });
      },
      fileUploaded(data) {
        this.cur_map.img_addr = data.file;
      },
      click(ev) {
        const x = ev.offsetX;
        const y = ev.offsetY;
        const item = this.getCurItem(x, y);
        if (item) {
          ev.stopPropagation();
          if (item.shape === 'label') {
            this.selectLabel(item);
          } else {
            this.selectItem(item);
          }
        } else {
          this.clearSelects();
        }
      },
      selectMap(map_id) {
        this.clearSelects();
        this.cur_map = this.map_hash[map_id];
        this.reDraw();
      },
      handleUpdateData(data) {
        this.$Message.success('保存成功!');
      },
      handleUpdateFail(ev) {
        this.$Modal.error({title: '保存出错', content: ev.message});
      },
      toggleFullScreen() {
        this.full_screen = !this.full_screen;
      },
      pageKeyDown(ev) {
        if (this.select_items.length) {
          const code = ev.keyCode;
          this.select_items.forEach((item) => {
            switch (code) {
            case 38:
              this.itemMove(item, 'up');
              break;
            case 40:
              this.itemMove(item, 'down');
              break;
            case 37:
              this.itemMove(item, 'left');
              break;
            case 39:
              this.itemMove(item, 'right');
              break;
            }
          });
          this.reDraw();
        }
        if (this.select_labels.length) {
          const code = ev.keyCode;
          this.select_labels.forEach((label) => {
            switch (code) {
            case 38:
              this.labelMove(label, 'up');
              break;
            case 40:
              this.labelMove(label, 'down');
              break;
            case 37:
              this.labelMove(label, 'left');
              break;
            case 39:
              this.labelMove(label, 'right');
              break;
            }
          });
          this.reDraw();
        }
      },
      itemMove(item, direction, step = 1) {
        const shape = item.shape;
        const d = item.data;
        if (shape === 'line') {
          switch (direction) {
          case 'up':
            d.y1 -= step;
            d.y2 -= step;
            break;
          case 'down':
            d.y1 += step;
            d.y2 += step;
            break;
          case 'left':
            d.x1 -= step;
            d.x2 -= step;
            break;
          case 'right':
            d.x1 += step;
            d.x2 += step;
            break;
          }
        }
        else if (['rectangle', 'ellipse', 'circle', 'arc'].indexOf(shape) > -1) {
          switch (direction) {
          case 'up':
            d.y -= step;
            break;
          case 'down':
            d.y += step;
            break;
          case 'left':
            d.x -= step;
            break;
          case 'right':
            d.x += step;
            break;
          }
        }
        else if (['linearPath', 'polygon', 'curve'].indexOf(shape) > -1) {
          switch (direction) {
          case 'up':
            d.points.forEach((p) => {
              p.y -= step;
            });
            break;
          case 'down':
            d.points.forEach((p) => {
              p.y += step;
            });
            break;
          case 'left':
            d.points.forEach((p) => {
              p.x -= step;
            });
            break;
          case 'right':
            d.points.forEach((p) => {
              p.x += step;
            });
            break;
          }
        }
      },
      mouseOver() {
        this.show_coordinate = true;
      },
      mouseOut() {
        this.show_coordinate = false;
      },
      mouseMove(ev) {
        this.coordinate.x = ev.offsetX;
        this.coordinate.y = ev.offsetY;
        //console.log(ev);
      },
      mouseDown(ev) {
        if (this.new_item) {
          const x = ev.offsetX;
          const y = ev.offsetY;
          const d = this.new_item.data;
          switch (this.new_item.shape) {
          case 'line':
            d.x1 = x;
            d.y1 = y;
            d.x2 = x + 20;
            d.y2 = y + 20;
            break;
          case 'rectangle':
            d.x = x;
            d.y = y;
            break;
          case 'ellipse':
            d.x = x;
            d.y = y;
            break;
          case 'circle':
            d.x = x;
            d.y = y;
            break;
          case 'linearPath':
            d.points = [];
            d.points.push({x: x, y: y});
            d.points.push({x: x + 10, y: y + 20});
            d.points.push({x: x + 20, y: y});
            break;
          case 'polygon':
            d.points = [];
            d.points.push({x: x, y: y});
            d.points.push({x: x + 25, y: y + 50});
            d.points.push({x: x + 50, y: y});
            break;
          case 'arc':
            d.x = x;
            d.y = y;
            break;
          case 'curve':
            d.points = [];
            d.points.push({x: x, y: y});
            d.points.push({x: x + 10, y: y + 20});
            d.points.push({x: x + 20, y: y});
            break;
          case 'path':
            break;
          default:
            console.error('undefined shape', item);
            break;
          }
          this.cur_map.items.push(this.new_item);
          this.selectItem(this.new_item);
          this.new_item = null;
        }
        if (this.new_label) {
          this.new_label.x = ev.offsetX;
          this.new_label.y = ev.offsetY;
          this.cur_map.labels.push(this.new_label);
          this.selectLabel(this.new_label);
          this.new_label = null;
        }
      },
      addShape(shape) {
        const new_data = Object.assign(Util.clone(this.default_item[shape]), {options: Util.clone(this.default_option)});
        this.new_item = {id: Util.guid(), shape: shape, data: new_data};
      },
      isShapeActive(shape) {
        return this.new_item && this.new_item.shape === shape;
      },
      getCurItem(x, y) {
        const items = this.cur_map.labels.concat(this.cur_map.items);
        const len = items.length;
        let target;
        for (let i = len - 1; i >= 0; i--) {
          const item = items[i];
          if (this.isPointInItem(item, x, y)) {
            target = item;
            break;
          }
        }
        return target;
      },
      isPointInItem(item, x, y) {
        let flag = false;
        switch (item.shape) {
        case 'line':
          flag = RoughUtil.isPointInLine(item, x, y);
          break;
        case 'rectangle':
          flag = RoughUtil.isPointInRectangle(item, x, y);
          break;
        case 'ellipse':
          flag = RoughUtil.isPointInEllipse(item, x, y);
          break;
        case 'circle':
          flag = RoughUtil.isPointInCircle(item, x, y);
          break;
        case 'linearPath':
          flag = RoughUtil.isPointInLinearPath(item, x, y);
          break;
        case 'polygon':
          flag = RoughUtil.isPointInPolygon(item, x, y);
          break;
        case 'arc':
          flag = RoughUtil.isPointInArc(item, x, y);
          break;
        case 'curve':
          flag = RoughUtil.isPointInCurve(item, x, y);
          break;
        case 'label':
          flag = RoughUtil.isPointInLabel(item, x, y);
          break;
        }
        return flag;
      },
      selectItem(item, is_add) {
        this.select_labels = [];
        if (!is_add) {
          this.select_items = [];
        }
        if (!this.isItemSelected(item)) {
          this.select_items.push(item);
          this.reDraw();
        }
      },
      selectAllItem() {
        this.select_items = [];
        this.cur_map.items.forEach((item) => {
          this.select_items.push(item);
        });
        this.reDraw();
      },
      clearSelects() {
        const has_selected = !!this.select_items.length || !!this.select_labels.length;
        this.select_items = [];
        this.select_labels = [];
        has_selected && this.reDraw();
      },
      isItemSelected(item) {
        const len = this.select_items.length;
        let flag = false;
        for (let i = len - 1; i >= 0; i--) {
          if (item === this.select_items[i]) {
            flag = true;
            break;
          }
        }
        return flag;
      },
      copyItem(item, index) {
        const new_item = Util.clone(item);
        this.cur_map.items.splice(index, 0, new_item);
        this.selectItem(new_item);
      },
      delItem(item) {
        Util.removeArrayItem(this.cur_map.items, item);
        Util.removeArrayItem(this.select_items, item);
        this.reDraw();
      },
      genShape(item) {
        let shape;
        const d = item.data;
        switch (item.shape) {
        case 'line':
          shape = this.generator.line(d.x1, d.y1, d.x2, d.y2, d.options);
          break;
        case 'rectangle':
          shape = this.generator.rectangle(d.x, d.y, d.w, d.h, d.options);
          break;
        case 'ellipse':
          shape = this.generator.ellipse(d.x, d.y, d.w, d.h, d.options);
          break;
        case 'circle':
          shape = this.generator.circle(d.x, d.y, d.d, d.options);
          break;
        case 'linearPath':
          shape = this.generator.linearPath(this.getPoints(d.points), d.options);
          break;
        case 'polygon':
          shape = this.generator.polygon(this.getPoints(d.points), d.options);
          break;
        case 'arc':
          shape = this.generator.arc(d.x, d.y, d.w, d.h, d.start, d.stop, d.closed, d.options);
          break;
        case 'curve':
          shape = this.generator.curve(this.getPoints(d.points), d.options);
          break;
        case 'path':
          shape = this.generator.path(d.val, d.options);
          break;
        default:
          console.error('undefined shape', item);
          break;
        }
        return shape;
      },
      getPoints(points) {
        const arr = [];
        points.forEach((point) => {
          arr.push([point.x, point.y]);
        });
        return arr;
      },
      addLabel() {
        this.new_label = Object.assign(Util.clone(this.default_label), {id: Util.guid()});
      },
      isLabelActive() {
        return !!this.new_label;
      },
      selectLabel(label, is_add) {
        this.select_items = [];
        if (!is_add) {
          this.select_labels = [];
        }
        if (!this.isLabelSelected(label)) {
          this.select_labels.push(label);
          this.reDraw();
        }
      },
      labelMove(label, direction, step = 1) {
        switch (direction) {
        case 'up':
          label.y -= step;
          break;
        case 'down':
          label.y += step;
          break;
        case 'left':
          label.x -= step;
          break;
        case 'right':
          label.x += step;
          break;
        }
      },
      copyLabel(label, index) {
        const new_label = Util.clone(label);
        this.cur_map.labels.splice(index, 0, new_label);
        this.selectLabel(new_label);
      },
      delLabel(label) {
        Util.removeArrayItem(this.cur_map.labels, label);
        Util.removeArrayItem(this.select_labels, label);
        this.reDraw();
      },
      isLabelSelected(label) {
        const len = this.select_labels.length;
        let flag = false;
        for (let i = len - 1; i >= 0; i--) {
          if (label === this.select_labels[i]) {
            flag = true;
            break;
          }
        }
        return flag;
      },
      labelStyle(label) {
        return {
          top: label.y + 'px',
          left: label.x + 'px',
        }
      },
      drawItem(item) {
        const shape = this.genShape(item);
        this.rc.draw(shape);
      },
      drawLabel(label) {
        const font_size = label.fontSize || 30;
        const font = `${label.fontWeight} ${font_size}px ${label.font}`;
        this.ctx.font = font;
        this.ctx.fillStyle = label.fillStyle;
        this.ctx.textAlign = label.textAlign;
        this.ctx.textBaseline = label.textBaseline;
        label.w = this.ctx.measureText(label.text).width;
        label.h = font_size;
        this.ctx.fillText(label.text, label.x, label.y);
      },
      hlItem(item) {
        const hl_item = Util.clone(item);
        Object.assign(hl_item.data.options, {
          stroke: this.hl_color,
          strokeWidth: hl_item.data.options.strokeWidth + 1
        });
        const shape = this.genShape(hl_item);
        this.rc.draw(shape);
      },
      removeHlItem(item) {
        setTimeout(() => {
          this.reDraw();
        }, 500);
      },
      hlLabel(label) {
        const padding = 3;
        const poly = {
          shape: 'polygon',
          data: {
            points: [
              {x: label.x - padding, y: label.y - padding * 2},
              {x: label.x + label.w + padding, y: label.y - padding * 2},
              {x: label.x + label.w + padding, y: label.y + label.h + padding},
              {x: label.x - padding, y: label.y + label.h + padding},
            ],
            options: {
              stroke: this.hl_color,
              strokeWidth: 2
            },
          },
        };
        const shape = this.genShape(poly);
        this.rc.draw(shape);
      },
      draw() {
        // 绘制图形
        this.cur_map.items.forEach((item) => {
          this.drawItem(item);
        });
        // 高亮选中的图形
        this.select_items.forEach((select_item) => {
          this.hlItem(select_item);
        });
        // 绘制标签
        this.cur_map.labels.forEach((label) => {
          this.drawLabel(label);
        });
        // 高亮选中的标签
        this.select_labels.forEach((label) => {
          this.hlLabel(label);
        });
      },
      reDraw() {
        this.ctx.clearRect(0, 0, this.canvas_width, this.canvas_height);
        this.draw();
      }
    }
  }
</script>
